import React, { useContext } from "react";
import type { IChosenItem } from "../../../../../@types/chosenItems";
import type { IWebsiteKeywordsPageFilters } from "app/pages/website-analysis/traffic-sources/search/components/WebsiteKeywordsPageTypes";
import type { IWidgetTableResult } from "app/components/widget/widget-types/TableWidget";
import type { RankingDistributionMetric } from "app/pages/keyword-research/website-analysis/pages/ranking-distribution/rankingDistribution.types";

export interface IRankingDistributionTableTopContext {
    chosenItems: IChosenItem[];
    tableFilters: IWebsiteKeywordsPageFilters;
    onBrandedNonBrandedChange: (value) => void;
    onPhraseChange: (value) => void;
    onVolumeChange: (value) => void;
    onCpcChange: (value) => void;
    onSerpFilterApply: (features) => void;
    onPositionTrendChange: (positionTrendValue: string) => void;
    isCompare: boolean;
    metric: RankingDistributionMetric;
    tableData: IWidgetTableResult;
    onUrlBooleanChange: (includeUrls?: string, excludeUrls?: string) => void;
    onKeywordBooleanChange: (
        includeKeywords?: string,
        includeKeywordGroups?: string,
        excludeKeywords?: string,
        excludeKeywordGroups?: string,
    ) => void;
    pageFilter?: string;
}

const RankingDistributionTableTopContext = React.createContext<IRankingDistributionTableTopContext>(null);
export const RankingDistributionTableTopContextProvider = RankingDistributionTableTopContext.Provider;

export const useRankingDistributionTableTopContext = (): IRankingDistributionTableTopContext =>
    useContext(RankingDistributionTableTopContext);
